import { makeStyles } from '@material-ui/core';
import { ILesson } from 'interface/course';
import { useEffect, useState } from 'react';
import Lesson from './Lesson';

interface IProps {
  lessons: ILesson[];
  blockedModule: boolean;
  progress?: number;
}

const useStyles = makeStyles((theme) => ({
  container: {
    overflow: 'hidden',
    '@media(max-width: 425px)': {
      padding: theme.spacing(4),
      paddingBottom: 0,
    },
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(6),
    paddingBottom: theme.spacing(2),
    '& > div:nth-child(2) > div:first-child': {
      background: theme.palette.safevideo.main,
      height: '100%',
      transform: 'translateY(calc(-50% + 11px))',
      alignItems: 'flex-end',
    },
    '& > div:last-of-type > div:first-child': {
      background: theme.palette.safevideo.main,
      height: '100%',
      transform: 'translateY(calc(50% - 11px))',
    },
  },
  watchedProgress: {
    '@media(max-width: 425px)': {
      display: 'none',
    },
    top: 10,
    left: 37,
    position: 'absolute',
    background: theme.palette.common.white,
    width: 1,
    height: '100%',
    zIndex: 1,
    '& > div': {
      width: '100%',
      background: theme.palette.primary.main,
    },
  },
}));

const Lessons = (props: IProps) => {
  const [progress, setProgress] = useState(0);
  const classes = useStyles();

  useEffect(() => {
    if (!props.lessons) return;
    const lastWatched = [...props.lessons].reverse().find((lesson) => lesson.watched);
    const lessonIndex = props.lessons.findIndex((lesson) => lesson.id === lastWatched?.id) ?? 0;
    if (props.lessons.length) {
      const weight = 100 / props.lessons.length;
      setProgress(weight * (lessonIndex + 1));
    }
  }, [props.lessons]);

  return (
    <div aria-label='lista de aulas do módulo' className={classes.container}>
      {(props.lessons ?? []).length > 1 && (
        <div className={classes.watchedProgress}>
          <div style={{ height: `${progress}%` }} />
        </div>
      )}
      {props.lessons.map((lesson, key) => (
        <Lesson key={key} lesson={lesson} blockedModule={props.blockedModule} />
      ))}
    </div>
  );
};

export default Lessons;
